import React from 'react'
import { useTranslation } from 'next-i18next'
import { ensurePartnerIdAndCampaign } from '../../lib/helper/helper'
import { IdealImage } from './IdealImage'
import Link from '../overwrites/Link'

type Props = {
  product_link?: string
  coverImage?: Image
  name?: string
}

export function Widget({ product_link, coverImage, name }: Props) {
  const { t } = useTranslation()

  if (!product_link) return null
  const isExternal = (href: string) =>
    !href.startsWith('/') && !href.startsWith('#')

  const widgetContent = (
    <div className="mx-3 xs:mx-8 flex flex-col gap-4 z-20 text-white mb-4 xs:mb-12 items-start">
      <div className="text-3xl xs:text-left text-center font-medium uppercase">
        {t('discover-activities-in', { name })}
      </div>
      <div className="w-full xs:w-auto bg-white text-black px-6 py-3 rounded-md text-lg font-bold text-center uppercase hover:bg-primary hover:text-white transition-colors">
        {t('book-tickets-online')}
      </div>
    </div>
  )

  return (
    <Link
      href={ensurePartnerIdAndCampaign(product_link)}
      target={isExternal(product_link) ? '_blank' : undefined}
      rel={isExternal(product_link) ? 'noopener noreferrer' : undefined}
      className="block mx-3 xs:mx-0 rounded-lg overflow-hidden relative h-120 my-10 group hover:cursor-pointer"
    >
      <div className="absolute inset-0 z-0 xs:rounded-md overflow-hidden group-hover:scale-110 transition-transform duration-300 ease-in-out">
        <IdealImage alt={name} title={name} image={coverImage} />
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-1/2 z-20 xs:rounded-md overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent"></div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-1/2 z-20 xs:rounded-md overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
      </div>
      <div className="flex flex-col items-stretch justify-end xs:justify-end gap-16 h-full z-40">
        {widgetContent}
      </div>
    </Link>
  )
}
